import './HistoryChart.less';
import React from 'react';
import { inject, observer } from 'mobx-react';

@inject('SafetyStore')
@observer
class CustomizedContainer extends React.Component {
  render() {
    const {
      cx,
      cy,
      connectNulls,
      value,
      SafetyStore,
      targetScores,
      index
    } = this.props;
    let safetyScore = SafetyStore.safetyScoreIsValid(value)
      ? Number(value)
      : null;

    let targetScore = SafetyStore.safetyScoreIsValid(targetScores[index])
      ? Number(targetScores[index])
      : null;

    // style class names
    const noTargetDotColor = 'safety-chart-no-target-dot',
      targetLessThanScoreDotColor = 'safety-chart-target-less-than-score-dot',
      targetGreaterThanScoreDotColor =
        'safety-chart-target-greater-than-score-dot',
      noTargetRectColor = 'safety-chart-no-target-rect',
      targetLessThanScoreRectColor = 'safety-chart-target-less-than-score-rect',
      targetGreaterThanScoreRectColor =
        'safety-chart-target-greater-than-score-rect';

    // Don't draw container if there is no value or this is the dotted line
    if (safetyScore === null || connectNulls === true) {
      return null;
    }

    return (
      <g>
        <g>
          <circle
            cx={cx}
            cy={cy}
            r="4"
            className={
              targetScore === null
                ? noTargetDotColor
                : safetyScore <= targetScore
                ? targetGreaterThanScoreDotColor
                : targetLessThanScoreDotColor
            }
          />
        </g>
        <g>
          <rect
            x={cx - 17}
            y={cy - 32}
            width={35}
            height={22}
            className={
              targetScore === null
                ? noTargetRectColor
                : safetyScore <= targetScore
                ? targetGreaterThanScoreRectColor
                : targetLessThanScoreRectColor
            }
          />
        </g>
      </g>
    );
  }
}

export default CustomizedContainer;



// WEBPACK FOOTER //
// ./src/containers/Safety/HistoryChart/CustomizedContainer.jsx